import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

export const Header = ({ transparent = false }) => {
  const navigate = useNavigate();

  const headerClass = transparent 
    ? 'header-transparent' 
    : 'header-solid bg-white border-b border-gray-200 shadow-sm';

  return (
    <header className={`app-header ${headerClass} fixed top-0 left-0 right-0 z-50 px-6 py-3`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div 
          className="cursor-pointer hover:opacity-80 transition-opacity flex items-center gap-3"
          onClick={() => navigate('/')}
        >
          <Logo size="small" showText={true} />
          <span className="header-claim hidden md:block">
            Where minds meet to grow
          </span>
        </div>
        
        <Button 
          variant="ghost" 
          size="sm"
          onClick={() => navigate('/')}
          className="flex items-center gap-2"
        >
          <Home className="h-4 w-4" />
          Home
        </Button>
      </div>
    </header>
  );
};

export default Header;
